import React from 'react';
import { FormControlLabel, Checkbox, TextField, Box } from '@mui/material';
import { useImportWizardStore } from '../../store/useImportWizardStore';

/**
 * Checkbox for "Save this configuration" with a conditional name input.
 * Updates saveConfigName in the store.
 *
 * Validates: Requirements 10.1, 10.2
 */
const SaveConfigToggle: React.FC = () => {
  const saveConfigName = useImportWizardStore((s) => s.saveConfigName);
  const setSaveConfigName = useImportWizardStore((s) => s.setSaveConfigName);

  const isChecked = saveConfigName !== null;

  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setSaveConfigName('');
    } else {
      setSaveConfigName(null);
    }
  };

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSaveConfigName(event.target.value);
  };

  return (
    <Box>
      <FormControlLabel
        control={
          <Checkbox
            checked={isChecked}
            onChange={handleToggle}
            inputProps={{ 'aria-label': 'Save this configuration' }}
          />
        }
        label="Save this configuration for future use"
      />
      {isChecked && (
        <TextField
          fullWidth
          label="Configuration Name"
          value={saveConfigName ?? ''}
          onChange={handleNameChange}
          placeholder="Enter a name for this configuration"
          sx={{ mt: 1 }}
          required
          inputProps={{ 'aria-label': 'Configuration name' }}
        />
      )}
    </Box>
  );
};

export default SaveConfigToggle;
